import {Flex} from 'antd';
import React from 'react';

import PageContent from '../../components/PageContent/PageContent';
import MainTableTitle from '../../components/Table/Utils/MainTableTitle';

import PCFStudiesTable from './utils/PCFStudiesTable';

const PCFStudiesList: React.FC = () => {
  return (
    <Flex
      vertical
      justify="space-between"
      align="center"
      gap={24}
      style={{height: '100%', width: '100%'}}
    >
      <Flex
        vertical={false}
        justify="space-between"
        align="center"
        style={{width: '100%'}}
      >
        <MainTableTitle
          title="Product Carbon Footprint (PCF)"
          showDivider={false}
        />
      </Flex>
      <PageContent>
        <PCFStudiesTable />
      </PageContent>
    </Flex>
  );
};

export default PCFStudiesList;
